import { Box, Modal } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ManagePermission from "../components/Collections/ManagePermissionsModal";
import Loader from "../components/general/Loader";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NoData from "../components/general/NoData";
import ReusableButton from "../components/general/ReusableButton";
import ApproveModal from "../components/modal/ApproveModal";
import DeleteModal from "../components/modal/DeleteModal";
import DuplicateTask from "../components/modal/DuplicateTask";
import VerfiyCollectionModal from "../components/modal/VerfiyCollectionModal";
import HeavyTable from "../components/table/HeavyTable";
import { showWarningSwal } from "../functions/alert";
import { deleteCollection } from "../functions/deleteData";
import {
  buildQueryString,
  cancelAction,
  changeViewOptions,
  checkIfAllSelectedRowsMatchStatus,
  
  
  makeSureIsArray,
} from "../functions/general";
import { enhancedCollections } from "../functions/getData";
import { duplicateCollections, verfiycollection } from "../functions/postData";
import { showNotification } from "../functions/snackbar";

import PageHeader from "../components/ui/PageHeader";
import TableCard from "../components/ui/TableCard";
import TableToolbar from "../components/ui/TableToolbar";
import SearchInput from "../components/ui/SearchInput";
import { useEnhancedFilters } from "../components/ui/useFilterDrawer";
const collectionHeader = [
  { id: "identifier", label: "Collection Identifier" },
  { id: "name", label: "Collection Name" },
  { id: "status", label: "Status" },
  { id: "description", label: "Description" },
  { id: "tags", label: "Tags" },
  { id: "grade_difficulty", label: "Recommended Difficulty" },
  { id: "sections", label: "No. of section" },
  // { id: 'noOfQuestions', label: 'No. of questions' },
  { id: "initial_points", label: "Initial Points" },
  { id: "time_to_solve", label: "Time to solve" },
  { id: "competitions", label: "Competition" },
  // { id: 'permission', label: 'Permission to Verify' },
  { id: "created_by", label: "Created By" },
  { id: "last_modified_by", label: "Last Modified By" },
  // { id: 'lastVerifiedBy', label: 'Last Verified By' },
];

export default function EnhancedCollection() {
  document.title = "Collection";
  const isMounted = useRef(false);
  const user = useSelector((state) => state.user);
  const [header, setHeader] = useState(collectionHeader);
  const [collectionTable, setCollectionTable] = useState();
  const [viewOptions, setViewOptions] = useState([
    { label: "Tags", state: true, key: "private" },
    { label: "Recommended Difficulty", state: true, key: "address" },
    { label: "No. of Sections", state: true, key: "postal" },
    { label: "No. of Questions", state: true, key: "province" },
    { label: "Initial Points", state: true, key: "phone" },
    { label: "Time to Solve", state: true, key: "status" },
    { label: "Competition", state: true, key: "created_by_username" },
    { label: "Permission to Verify", state: true, key: "approved_by_username" },
    { label: "Created By", state: true, key: "rejected_by_username" },
    { label: "Last Modified By", state: true, key: "modified_by_username" },
    { label: "Last Verified By", state: true, key: "reject_reason" },
    { label: "Status", state: true, key: "status" },
  ]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [onDup, setOnDups] = useState(false);
  const [id, setId] = useState("");
  const [selected, setSelected] = useState([]);
  const [selecting, setSelecting] = useState([]);
  const [onDelete, setOnDelete] = useState(false);
  const [onApprove, setOnApprove] = useState(false);
  const [verfiy, setOnVerfiy] = useState(false);
  const [onManagePermission, setOnManagePermission] = useState(false);
  const [sortAbleColumns, setSortableColumns] = useState([]);

  // Consolidated query parameters state
  const [queryParams, setQueryParams] = useState({
    limits: 10,
    page: 1,
    search: "",
    tags: "",
    competitions: "",
    status: "",
    orderBy: "",
    orderDirection: "",
  });

  const cancelDelete = () => cancelAction(setOnDelete, setId);
  const cancelApprove = () => cancelAction(setOnApprove, setId);
  const cancelVerfiy = () => cancelAction(setOnVerfiy, setId);
  const cancelPermission = () => cancelAction(setOnManagePermission, setId);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const isFirstRender = useRef(true);

  // Update query parameters
  const updateQueryParams = (updates) => {
    setQueryParams((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  // Reset query parameters to initial state
  const resetQueryParams = () => {
    setQueryParams({
      limits: 10,
      page: 1,
      search: "",
      tags: "",
      competitions: "",
      status: "",
      orderBy: "",
      orderDirection: "",
    });
  };

  const adjustEndpoint = (endpoint, value, params = queryParams) => {
    const currentParams = { ...params };

    // Remove the current filter value if it's being changed
    if (value !== currentParams.competitions && currentParams.competitions) {
      endpoint += `&competitions=${currentParams.competitions}`;
    }
    if (value !== currentParams.tags && currentParams.tags) {
      endpoint += `&tags=${currentParams.tags}`;
    }
    if (value !== currentParams.status && currentParams.status) {
      endpoint += `&status=${currentParams.status}`;
    }

    return endpoint;
  };

  const filters = [
    {
      label: "Tags",
      endpoint: "collection/list?get_filter=tags",
      value: queryParams.tags,
      onChange: (value) => updateQueryParams({ tags: value }),
      key: "tags",
      setValue: (value) => updateQueryParams({ tags: value }),
    },
    {
      label: "Competition",
      endpoint: "collection/list?get_filter=competitions",
      value: queryParams.competitions,
      onChange: (value) => updateQueryParams({ competitions: value }),
      key: "competitions",
      setValue: (value) => updateQueryParams({ competitions: value }),
    },
    {
      label: "Status",
      endpoint: "collection/list?get_filter=status",
      value: queryParams.status,
      onChange: (value) => updateQueryParams({ status: value }),
      key: "status",
      setValue: (value) => updateQueryParams({ status: value }),
    },
  ];

  const afterFunction = (cancel, data) => {
    if ([200, 201].includes(data.status)) {
      resetQueryParams();
      setSearch("");
      fetchData();
      cancel();
      showNotification("success", data.message, enqueueSnackbar, closeSnackbar);
      setSelected([]);
      setSelecting([]);
    }
  };
  const canceldubs = () => cancelAction(setOnDups);

  const deleteFunction = () => {
    console.log({ id: id === "" ? selected : [id] });
    setLoading(true);
    deleteCollection({ id: id === "" ? selected : [id] }).then((d) => {
      fetchData();
      cancelDelete();
      setLoading(false);
    });
  };
  const approveFunction = () => {
    setLoading(true);
  };

  const onChangeSearch = (value) => {
    setSearch(value);
    updateQueryParams({ search: value });
  };

  const fetchData = () => {
    setSelected([]);
    setSelecting([]);
    setLoading(true);

    const queryString = buildQueryString(queryParams);
    enhancedCollections(queryString, controller.current?.signal).then((res) => {
      console.log(res);
      setCollectionTable(res);
      setSortableColumns(res?.sortable_columns);
      setLoading(false);
    });
  };

  const onChangeViewOptions = (value) =>
    changeViewOptions(collectionHeader, setViewOptions, setHeader, value);

  const handleSortingFunction = (sortingKey, direction) => {
    updateQueryParams({
      orderBy: sortingKey,
      orderDirection: direction,
    });
  };

  const onChangePage = (pageNo) => {
    updateQueryParams({ page: pageNo });
  };

  const onChangeRowsPerPage = (numberOfRows) => {
    setRowsPerPage(numberOfRows);
    updateQueryParams({ limits: numberOfRows });
  };

  const controller = useRef(null);

  // Effect for handling URL changes and initial setup
  useEffect(() => {
    if (isFirstRender.current) isFirstRender.current = false;
    isMounted.current = true;

    // Create a new abort controller for this effect
    controller.current = new AbortController();

    // Initial data fetch
    setSelected([]);
    setSelecting([]);
    setLoading(true);

    const queryString = buildQueryString(queryParams);
    enhancedCollections(queryString, controller.current.signal).then((res) => {
      console.log(res);
      setCollectionTable(res);
      setSortableColumns(res?.sortable_columns);
      setLoading(false);
    });

    return () => {
      if (controller.current) {
        controller.current.abort();
      }
      isMounted.current = false;
    };
  }, []);

  // Effect for data fetching when query parameters change
  useEffect(() => {
    if (controller.current && !isFirstRender.current) {
      setSelected([]);
      setSelecting([]);
      setLoading(true);

      const queryString = buildQueryString(queryParams);
      enhancedCollections(queryString, controller.current.signal).then(
        (res) => {
          console.log(res);
          setCollectionTable(res);
          setSortableColumns(res?.sortable_columns);
          setLoading(false);
        }
      );
    }
  }, [queryParams]);

  const onClickAddToCompetition = () => {
    // return selected.length ? {} :
    //     showWarningSwal('Please select at least one collection to add to competition')
  };
  const onClickMassApprove = () => {
    return collectionTable &&
      checkIfAllSelectedRowsMatchStatus(
        selected,
        collectionTable.data,
        ["pending"],
        user
      )
      ? setOnApprove(true)
      : showWarningSwal(
          "Please only select pending collections that are not added by you to mass approve"
        );
  };
  const onClickMassDelete = () => {
    return selected.length
      ? setOnDelete(true)
      : showWarningSwal("Please select at least one collection to mass delete");
  };
  const duplicate = () => {
    duplicateCollections(id).then((d) => {
      console.log(d);
      afterFunction(canceldubs, d);
    });
  };
  const virfycollection = () => {
    verfiycollection(id).then((d) => {
      afterFunction(cancelVerfiy, d);
    });
  };

  const enhancedFilters = useEnhancedFilters({ filters, adjustEndpoint });

  const total = collectionTable?.total ?? collectionTable?.meta?.total;

  return (
    <Box className="wrapperBox simcc-page">
      <LoadingBackdrop loading={loading} />
      <PageHeader
        title="Collections"
        actions={
          <>
            <>
              <ReusableButton variant="primary" text="Add Collection" to="/addcollection" iconType="add" />
              <ReusableButton variant="ghost" text="Add To Competition" onClick={() => onClickAddToCompetition()} iconType="add" />
              <ReusableButton variant="ghost" text="Mass Approve" onClick={() => onClickMassApprove()} iconType="check" />
              <ReusableButton variant="danger" text="Mass Delete" onClick={() => onClickMassDelete()} iconType="delete" />
            </>
          </>
        }
      />
      <TableCard
        toolbar={
          <TableToolbar
            search={<SearchInput state={search} setState={onChangeSearch} placeholder="Search collection name and collection identifier" ariaLabel={"Search only in \"Collection Name and Collection Identifier\" columns"} />}
            onOpenFilters={enhancedFilters.openDrawer}
            filtersOpen={enhancedFilters.isOpen}
            filterCount={enhancedFilters.count}
            meta={total !== undefined && `${Number(total).toLocaleString()} collections`}
          />
        }
        chips={enhancedFilters.chips}
      >
        {loadingTable && <Loader height={600} />}
        {!loadingTable &&
          collectionTable &&
          makeSureIsArray(collectionTable.data).length && (
            <HeavyTable bare onChangeRowsPerPage={onChangeRowsPerPage}
              handleSortingFunction={handleSortingFunction}
              sortableKeys={sortAbleColumns}
              setOnVerfiy={setOnVerfiy}
              headers={header}
              list={collectionTable}
              title="collection"
              rowsPerPage={rowsPerPage}
              setOnManagePermission={setOnManagePermission}
              setOnDups={setOnDups}
              setOnDelete={setOnDelete}
              onChangePage={onChangePage}
              fixed={["name", "identifier"]}
              selecting={selecting}
              setSelecting={setSelecting}
              selected={selected}
              setSelected={setSelected}
              setId={setId}
            />
          )}
        {!loadingTable &&
          firstLoaded &&
          collectionTable &&
          !makeSureIsArray(collectionTable.data).length && (
            <NoData height={600} />
          )}
      </TableCard>
      {enhancedFilters.drawer}
      <Modal open={onDelete} onClose={() => cancelDelete()}>
        <>
          {Boolean(collectionTable) && (
            <DeleteModal
              table={collectionTable}
              id={id}
              selected={selected}
              deleteFunction={deleteFunction}
              cancelDelete={cancelDelete}
            />
          )}
        </>
      </Modal>
      <Modal open={onApprove} onClose={() => cancelApprove()}>
        <>
          {Boolean(collectionTable) && (
            <ApproveModal
              table={collectionTable}
              id={id}
              selected={selected}
              approveFunction={approveFunction}
              cancelApprove={cancelApprove}
              object="collection"
            />
          )}
        </>
      </Modal>
      <Modal open={onManagePermission} onClose={() => cancelPermission()}>
        <>
          {Boolean(collectionTable) && (
            <ManagePermission
              table={collectionTable}
              id={id}
              selected={selected}
              approveFunction={approveFunction}
              cancelApprove={cancelApprove}
              object="collection"
            />
          )}
        </>
      </Modal>
      <Modal open={onDup} onClose={() => canceldubs()}>
        <>
          {Boolean(collectionTable) && (
            <DuplicateTask
              canceldub={canceldubs}
              id={id}
              duplicate={duplicate}
              table={collectionTable}
            />
          )}
        </>
      </Modal>
      <Modal open={verfiy} onClose={() => cancelVerfiy()}>
        <>
          {Boolean(collectionTable) && (
            <VerfiyCollectionModal
              table={collectionTable}
              id={id}
              selected={selected}
              approveFunction={virfycollection}
              cancelApprove={cancelVerfiy}
            />
          )}
        </>
      </Modal>
    </Box>
  );
}
